module.exports = __webpack_public_path__ + "img/logo-breeze.3ff8f941.png";